import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ResponsiveContext } from 'grommet';
import styled from 'styled-components';
import {
  PageSection,
  SectionBody,
  SectionFooter,
  SectionHeader,
} from './PageSection';
import ResourceCard from './ResourceCard';
import Carousel from './Carousel';

const ItemsGrid = styled.div`
  @media ${({ theme }) => theme.custom.layouts.above_medium} {
    display: grid;
    grid-auto-rows: auto;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-gap: var(--gutters);
  }
`;

// eslint-disable-next-line no-unused-vars
const ResourcesSection = ({
  title,
  subtitle,
  resources,
  ctaLabel,
  ctaUrl,
  backgroundColor,
}) => {
  const layout = useContext(ResponsiveContext);
  const useMobileLayout = layout === 'small';

  const theme =
    ['dark', 'black'].indexOf(backgroundColor) >= 0 ? 'dark' : 'light';

  return (
    <PageSection backgroundColor={backgroundColor}>
      <SectionHeader title={title} subtitle={subtitle} theme={theme} />
      <SectionBody>
        {useMobileLayout ? (
          <Carousel
            variant={theme}
            options={{
              visibleSlides: 1,
              totalSlides: resources?.length,
            }}
          >
            {resources?.map((r, i) => (
              <ResourceCard key={i} {...r} />
            ))}
          </Carousel>
        ) : (
          <ItemsGrid>
            {resources?.map((r, i) => (
              <ResourceCard {...r} key={i} />
            ))}
          </ItemsGrid>
        )}
      </SectionBody>
      <SectionFooter ctaLabel={ctaLabel} ctaUrl={ctaUrl} />
    </PageSection>
  );
};

ResourcesSection.defaultProps = {
  subtitle: null,
  backgroundColor: 'light-grey',
};

ResourcesSection.propTypes = {
  backgroundColor: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.object,
  resources: PropTypes.arrayOf(PropTypes.object).isRequired,
  ctaLabel: PropTypes.string.isRequired,
  ctaUrl: PropTypes.string.isRequired,
};

export default ResourcesSection;
